import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";

import { ReportRow } from "../types";

interface ReportDataTableProps {
  rows: ReportRow[];
  emptyMessage: string;
}

const toTitle = (value: string) =>
  value
    .replace(/([A-Z])/g, " $1")
    .replace(/^./, (char) => char.toUpperCase());

const ReportDataTable = ({ rows, emptyMessage }: ReportDataTableProps) => {
  const columns = rows.length
    ? Object.keys(rows[0]).filter((column) => column !== "id")
    : [];

  return (
    <TableContainer component={Paper} variant="outlined" sx={{ borderRadius: 2, overflowX: "auto", "& .MuiTableCell-head": { bgcolor: "action.hover", color: "text.secondary", fontSize: ".72rem", fontWeight: 800, textTransform: "uppercase", whiteSpace: "nowrap" }, "& .MuiTableCell-body": { py: 1.35, borderColor: "divider" } }}>
      <Box sx={{ px: 2, py: 1.5, display: "flex", justifyContent: "space-between", alignItems: "center", borderBottom: "1px solid", borderColor: "divider" }}>
        <Typography fontWeight={800}>Report Records</Typography>
        <Typography variant="caption" color="text.secondary">{rows.length} records in this view</Typography>
      </Box>
      <Table size="small" sx={{ minWidth: 820 }}>
        <TableHead>
          <TableRow>
            {columns.map((column) => (
              <TableCell key={column}>
                <strong>{toTitle(column)}</strong>
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.length ? (
            rows.map((row) => (
              <TableRow key={row.id} hover>
                {columns.map((column) => (
                  <TableCell key={column}>{row[column] ?? "-"}</TableCell>
                ))}
              </TableRow>
            ))
          ) : (
            <TableRow>
              <TableCell colSpan={Math.max(columns.length, 1)}>
                <Typography py={4} textAlign="center" color="text.secondary">
                  {emptyMessage}
                </Typography>
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default ReportDataTable;
